// frontend/src/utils/api.js
// API utility functions with axios

import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
export const API_ORIGIN = new URL(API_URL).origin;

//  const API_URL = process.env.REACT_APP_API_URL


// const API_URL = 'https://istockly.onrender.com/api';
  // process.env.REACT_APP_API_URL
  //   ? `${process.env.REACT_APP_API_URL}/api`
  //   : 'http://localhost:5000/api';


// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

export const authAPI = {
  csrf: () => axios.get(`${API_ORIGIN}/sanctum/csrf-cookie`, { withCredentials: true }),
  registrationOptions: (config) => api.get('/auth/registration-options', config),
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/me'),
  updateProfile: (data) => api.patch('/me', data),
  updatePassword: (data) => api.put('/me/password', data),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

export const legalAPI = {
  get: (type, version, config = {}) => api.get(`/legal/${type}`, { ...config, params: { ...config.params, ...(version ? { version } : {}) } }),
};

// Courses API
export const coursesAPI = {
    getAll: (params, config = {}) => api.get('/courses', { ...config, params: { ...config.params, ...params } }),
  getBySlug: (slug) => api.get(`/courses/${slug}`),
  getCategories: () => api.get('/courses/meta/categories'),
};

// User API
export const userAPI = {
  getEnrolledCourses: () => api.get('/learning/dashboard'),
  getEnrolledLivePrograms: () => api.get('/me/live-programs'),
  getCertificates: () => api.get('/me/certificates'),
  downloadCertificate: (certificateId) => api.get(`/learning/certificates/${certificateId}/download`, { responseType: 'blob' }),
  checkCourseAccess: (courseId) => api.get(`/learning/courses/${courseId}/access`),
  getCourseWithProgress: (courseId) => api.get(`/learning/courses/${courseId}`),
  getLesson: (lessonId) => api.get(`/learning/lessons/${lessonId}`),
  resolvePlayback: (signedUrl) => api.get(signedUrl.replace(api.defaults.baseURL, '')),
  updateProgress: (lessonId, data) => api.put(`/learning/lessons/${lessonId}/progress`, data),
  getQuiz: (quizId) => api.get(`/learning/quizzes/${quizId}`),
  startQuiz: (quizId) => api.post(`/learning/quizzes/${quizId}/attempts`),
  submitQuiz: (attemptId, answers) => api.post(`/learning/quiz-attempts/${attemptId}/submit`, { answers }),
  getQuizAttempt: (attemptId) => api.get(`/learning/quiz-attempts/${attemptId}`),
  getAssignment: (assignmentId) => api.get(`/learning/assignments/${assignmentId}`),
  submitAssignment: (assignmentId, formData) => api.post(`/learning/assignments/${assignmentId}/submissions`, formData),
  getDashboardStats: () => api.get('/user/dashboard/stats'),
  syncUser: (data) => api.post('/user/sync', data),
};

// Admin API
export const adminAPI = {
  getAllCourses: () => api.get('/admin/courses'),
  getCourse: (id) => api.get(`/admin/courses/${id}`),
  createCourse: (data) => api.post('/admin/courses', data),
  updateCourse: (id, data) => api.put(`/admin/courses/${id}`, data),
  deleteCourse: (id) => api.delete(`/admin/courses/${id}`),
  togglePublish: (id) => api.patch(`/admin/courses/${id}/publish`),
  getAnalytics: () => api.get('/admin/analytics'),
  getUsers: (params) => api.get('/admin/users', { params }),
  getUserDetails: (userId) => api.get(`/admin/users/${userId}`),
  getUsersFromDB: () => api.get('/admin/users/db'),
  getRegisteredUsers: () => api.get('/admin/registered-users'),
};

// Payment API
export const paymentAPI = {
  initiate: (data) => api.post('/checkout/orders', data),
  verify: (data) => api.post('/checkout/verify', data),
  getHistory: () => api.get('/me/orders'),
  getOrder: (id, config = {}) => api.get(`/me/orders/${id}`, config),
  getSubscriptions: () => api.get('/me/subscriptions'),
  getSubscriptionPlans: (config = {}) => api.get('/subscription-plans', config),
  createSubscription: (planId) => api.post('/subscriptions', { plan_id: planId }),
  cancelSubscription: (id) => api.post(`/subscriptions/${id}/cancel`),
  downloadInvoice: (id) => api.get(`/me/invoices/${id}/download`, { responseType: 'blob' }),
};

// Upload API
export const uploadAPI = {
  uploadImage: (formData) => {
    return api.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteImage: (publicId) => api.delete(`/upload/image/${publicId.replace(/\//g, '___')}`),
};



// Live Programs API
export const liveProgramsAPI = {
  getAll: (params) => api.get('/live-programs', { params }),
  getByType: (type) => api.get('/live-programs', { params: { type } }),
  getBySlug: (slug) => api.get(`/live-programs/${slug}`),
  register: (id) => api.post(`/live-programs/${id}/register`),
  cancel: (id) => api.post(`/live-program-registrations/${id}/cancel`),
  mine: () => api.get('/me/live-programs'),
  join: (sessionId) => api.get(`/live-program-sessions/${sessionId}/join`),
};

export const offlineCentersAPI = {
  getAll: (params) => api.get('/offline-centers', { params }),
  getBySlug: (slug) => api.get(`/offline-centers/${slug}`),
};

// Admin Live Programs API
export const adminLiveProgramsAPI = {
  getAll: () => api.get('/admin/live-programs'),
  getById: (id) => api.get(`/admin/live-programs/${id}`),
  create: (data) => api.post('/admin/live-programs', data),
  update: (id, data) => api.put(`/admin/live-programs/${id}`, data),
  delete: (id) => api.delete(`/admin/live-programs/${id}`),
  togglePublish: (id) => api.patch(`/admin/live-programs/${id}/toggle-publish`),
};





// Settings API
export const settingsAPI = {
  getAll: () => api.get('/settings'),
  get: (key) => api.get(`/settings/${key}`),
  update: (key, value, description) => api.put(`/settings/${key}`, { value, description }),
  initialize: () => api.post('/settings/initialize'),
};

// Blog API
export const blogAPI = {
  getAll: (params) => api.get('/blog/posts', { params }),
  getBySlug: (slug) => api.get(`/blog/posts/${slug}`),
};

export const cmsAPI = {
  siteConfig: (config) => api.get('/site/config', config),
  homepage: (config) => api.get('/homepage', config),
  businessProfile: (config) => api.get('/business-profile', config),
  page: (slug) => api.get(`/pages/${slug}`),
  faqs: (params) => api.get('/faqs', { params }),
  testimonials: (params, config) => api.get('/testimonials', { ...config, params }),
  navigation: (location, config) => api.get(`/navigation/${location}`, config),
};

export default api;
